import { CDN_URLS } from '../../constants/cdn-urls';
import { DefaultIconProps } from './types';

export const PowerIcon = ({ className, ...props }: DefaultIconProps) => (
  <img
    className={className}
    src={`${CDN_URLS.FABLEBORNE}/assets/general/icons/power-icon.webp`}
    alt="power-icon"
    {...props}
  />
);
